module.exports = __webpack_public_path__ + "fonts/Roboto-Italic-VariableFont_wdth,wght.93df3bd.woff2";